// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"4ca1ea63","488":"d7b2364c"}[chunkId] + ".chunk.js";
};